import { parsePhoneNumberFromString } from "libphonenumber-js";

export const rules = {
  required: (v) => !!v || "This field is required",
  numberZero: (v) => !v || /^\d+$/.test(v) || "This field is required",
  number: (v) => !v || /^\d+$/.test(v) || "Enter a valid number",
  amount: (v) => !v || /^\d+$/.test(v) || "Enter a valid Amount",
  mobile: (v) => !v || /^(\d+)$/.test(v) || "Enter a valid mobile number",
  mobileLength: (v) => v?.length === 10 || "Enter a 10 digit mobile number",
  mobileNumber: (v) => {
    if (!v) return true;
    return /^\d{10}$/.test(v) || "Enter a valid 10 digit mobile number";
  },
  panNumber: (v) => {
    if (!v) return true; // Pass if empty (optional)
    return (
      /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) ||
      "Enter a valid PAN number (AAAAA1234A)"
    );
  },
  abcNumber: (v) => {
    if (!v) return true; // Pass if empty (optional)
    return /^\d{11,12}$/.test(v) || "Enter a valid ABC ID";
  },
  aadhaarNumber: (v) =>
    /^\d{12}$/.test(v) || "Enter a valid 12 digit Aadhaar number",
  debId: (v) => /^\d{11,12}$/.test(v) || "Enter a valid Deb ID",
  onlyString: (v) => /^[A-Za-z\s]+$/.test(v) || "This field should be valid",
  checkMarks: (type, total) => (v) => {
    if (!v) return "This field is required";

    if (type === "marks") {
      if (!/^[0-9]+$/.test(v)) {
        return "Enter valid mark";
      }
      const numeric = parseInt(v, 10);
      if (total != null && numeric > total) {
        return `Marks cannot exceed total`;
      }
    } else if (type === "grade") {
      return (
        /^(A\+?|B\+?|C\+?|D\+?|E|F)$/.test(v) ||
        "Enter valid grade (A, B, C, D, E, F, A+)"
      );
    } else if (type === "cgpa") {
      return /^(10|\d(\.\d{1,2})?)$/.test(v) || "Enter valid CGPA (0-10)";
    }
    return true;
  },
  NonvalidateMobileNumber: (v) => {
    if (!v) return true;
    return /^\d{10}$/.test(v) || "Enter a valid 10 digit mobile number";
  },
  passportNumberRule: (v) => {
    if (!v) return true;
    return (
      /^[A-Z][0-9]{7}$/.test(v) ||
      "Invalid passport number format (e.g., A1234567)"
    );
  },
  email: (v) => {
    if (!v) return true;
    return (
      (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) &&
        !/\.{2,}/.test(v)) ||
      "Enter a valid email address"
    );
  },
  applicaton_id: (v) =>
    !v || /^SASDODE\d{2}[12]\d{5}$/.test(v) || "Enter a valid ID",
  otp: (v) => !v || /^\d{6}$/.test(v) || "Enter a valid OTP",
  validMobile: (prefix) => (v) => {
    if (!v) return true;
    const fullNumber = `${prefix}${v}`;
    try {
      const phone = parsePhoneNumberFromString(fullNumber);
      return phone && phone.isValid() ? true : "Invalid mobile number";
    } catch (e) {
      return "Invalid phone number format";
    }
  },
  applicationNumber: (v) =>
    !v || v.length === 15 || "Enter a valid application number",
};
